import './Locales.css'

const Locales = () => {
    return (
        <picture>
            <img src='/assets/img/proximamente.png' alt='imagen proximamente' className="ProximamenteImg" />
        </picture>
    )
}

export default Locales